import { FC, useMemo } from 'react';
import { IconChangeRegular, IconCheckBold, Text, useBottomSheet } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';

import { ShopUxUbl, SortingItemListType } from '../../../types';

interface Props {
  sort_item_list: SortingItemListType[];
  onChange: (id: string, ubl?: ShopUxUbl | null) => void;
  buttonIcon?: React.ReactNode;
  buttonCss?: SerializedStyles;
  rootCss?: SerializedStyles;
}

export const SortButton: FC<React.PropsWithChildren<Props>> = ({
  sort_item_list,
  onChange,
  buttonIcon,
  buttonCss,
  rootCss,
}) => {
  const { open, close } = useBottomSheet('custom');

  const handleOpenBottomSheet = () => {
    open({
      children: (
        <SortList>
          {sort_item_list.map(({ id, name, selected, ubl }, index) => (
            <SortItem
              key={`${id}_${index}`}
              onClick={() => {
                onChange(id, ubl);
                close();
              }}
            >
              <Text as='span' variant='Body_16_SemiBold' color='textStrong'>
                {name}
              </Text>
              {selected && <IconCheckBold size={24} color='iconPrimary' />}
            </SortItem>
          ))}
        </SortList>
      ),
    });
  };

  const selectedItem = useMemo(() => sort_item_list.find((item) => item.selected), [sort_item_list]);

  return (
    <Root css={rootCss}>
      <Button onClick={handleOpenBottomSheet} css={buttonCss}>
        {buttonIcon ? buttonIcon : <IconChangeRegular color='iconSecondary' size={20} />}
        <Text as='span' variant='Body_13_Medium' color='textSecondary'>
          {selectedItem?.name}
        </Text>
      </Button>
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  padding: 5px;
`;

const Button = styled.button`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 2px;
`;

const SortList = styled.ul`
  padding: 0 16px 0;

  li {
    &:last-of-type {
      border: none;
    }
  }
`;

const SortItem = styled.li`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${vars.color.dividerThin};
  box-sizing: border-box;
  height: 56px;
  cursor: pointer;

  svg {
    margin-left: auto;
  }
`;
